<template>
    <v-menu offset-x :close-on-content-click="false" :nudge-top="200" v-model="menu" class="elevation-1">
        <v-btn icon slot="activator">
            <v-icon>person</v-icon>
        </v-btn>
        <v-card>
            <v-list>
                <v-list-tile>
                    <v-list-tile-content>
                        <v-list-tile-title class="body-1">{{ name }}</v-list-tile-title>
                        <v-list-tile-sub-title class="caption">{{ username }} &bull; {{ area }} &bull; ID {{ person.id }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="admin" v-if="isAdmin || isHired"> {{ $t('label.admin') }}</v-btn>
                <v-btn flat @click="prodam" v-if="isHired"> {{ $t('label.prodam') }}</v-btn>
                <v-btn flat @click="profile" small>{{ $t('label.profile') }}</v-btn>
                <v-btn flat @click="logout" small color="error">{{ $t('label.exit') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
// import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';

export default {
    data() {
        return {
            menu: false,
        };
    },
    computed: {
        isRoot() {
            return this.$store.getters.profile.isRoot;
        },
        isAdmin() {
            return this.isRoot || this.$store.getters.profile.isAdmin;
        },
        isHired() {
            return this.$store.getters.profile.isHired;
        },
        person() {
            return this.$store.getters.profile.person;
        },
        name() {
            return this.person.name;
        },
        username() {
            return this.person.username.toUpperCase();
        },
        area() {
            let area = {};
            if (this.person.area) {
                area = this.person.area;
            }
            return utilities.isEmpty(area.acronym) ? this.$t('label.hired') : area.acronym;
        },
    },
    methods: {
        admin() {
            this.menu = false;
            this.$router.push({ name: 'admin' });
        },
        prodam() {
            this.menu = false;
            this.$router.push({ name: 'prodam' });
        },
        logout() {
            this.$router.push({ name: 'logout' });
        },
        profile() {
            this.menu = false;

            const id = this.$store.getters.profile.person.id;
            this.$router.push({ name: 'personEdit', params: { id } });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Profile.vue